import { stringify } from 'qs';
import type { Logger } from '@devhacker/shared/libs/logger';
import type { IWordpressApi } from '~/types/api/wordpress';
import { API_URL, API_URL_PREFIX, API_TIMEOUT } from '~/constants/config';

import { createAxiosLikeFetch } from '@devhacker/shared/libs/fetch/createAxiosLikeFetch';
import { createLoggerInterceptors } from '@devhacker/shared/libs/logger';

type Params = {
  $logger: Logger;
};

const getUrl = (path: string, params: string = '', prefix: string = API_URL_PREFIX): string => {
  const removeFirstSlash = (value: string): string =>
    value.startsWith('/') ? value.slice(1) : value;
  return `${prefix}${path}/${removeFirstSlash(params)}`;
};

export default ({ $logger }: Params): IWordpressApi => {
  const wordpressFetch = createAxiosLikeFetch({
    baseURL: API_URL,
    timeout: API_TIMEOUT,
    credentials: 'include',
    ...createLoggerInterceptors($logger, 'wordpress'),
  });

  return {
    fetchMenus() {
      const url = getUrl('menus');
      return wordpressFetch(url);
    },
    subscribeToNewsletter(email: string) {
      const url = '/wp-json/subscriptions/v1/subscribe';
      return wordpressFetch(url, {
        method: 'post',
        body: stringify({ email, agree: true }),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    },
    async fetchIsLoggedIn() {
      // раньше было /api/logged, но были ошибки в google rich-results 499 код от nginx
      // однако это не должно иметь значения в будущем ведь мы обернули запрос в try/catch
      const { data } = await wordpressFetch('/wp-content/mu-plugins/lh-logged.php', {
        headers: {
          // нужно для проверки авторизации wordpress
          cookie: useRequestHeader('cookie') as string,
        },
      });
      return data;
    },
  };
};
